export default function($cookies, config) {
    'ngInject';
  
    const isCountryHeaderRequiredFor = url => {
      return url.indexOf('hafifmuzik/') > -1;
    };
  
    return {
      request(requestConfig) {
        const { url } = requestConfig;
        if (isCountryHeaderRequiredFor(url)) {
            const languageUI = $cookies.get(config.language.cookie) || 'tr';
            if(languageUI && !requestConfig.headers['language-ui']) {
              requestConfig.headers['language-ui'] = languageUI.toLowerCase();
            }
        }
        if(!!localStorage.getItem('showInApp')){
          requestConfig.url = requestConfig.url + (requestConfig.url.indexOf('?') > -1 ? '&agent=WEB' :'?agent=WEB' ); 
        }
        if ((config.environment === 'prod' || config.environment === 'gprd') && url.indexOf('hafifmuzik/mobile') > -1) {
          requestConfig.withCredentials = true;
        } else {
          requestConfig.withCredentials = false;
        }
  
        return requestConfig;
      }
    };
  }


// WEBPACK FOOTER //
// ./src/app/common/services/language.http-interceptor.service.ts